const COOKIE_NAME = 'keru_session';
const MAX_AGE_SECONDS = 8 * 60 * 60;

function getCookieDomain() {

    const configured = process.env.VUE_APP_COOKIE_DOMAIN;

    if (configured) {
        return configured;
    }

    const host = window.location.hostname;

    if (host === 'localhost' || host.endsWith('.localhost')) {
        return 'localhost';
    }

    const parts = host.split('.');

    if (parts.length <= 2) {
        return host;
    }

    const tld = parts[parts.length - 1];
    const sld = parts[parts.length - 2];
    const compoundSlds = ['com', 'co', 'net', 'org', 'gov', 'edu'];

    // TLD compuesto (p. ej. .com.co, .com.mx): el dominio registrable son 3 niveles.
    // Sin esto, keru.com.co => 'com.co', que es un public suffix y el navegador
    // RECHAZA la cookie => la sesión no se comparte entre subdominios del tenant.
    if (tld.length === 2 && compoundSlds.includes(sld)) {
        return parts.slice(-3).join('.');
    }

    return parts.slice(-2).join('.');
}

function isSecure() {
    return window.location.protocol === 'https:';
}

export function setSessionCookie(token, id) {

    if (!token) {
        return;
    }

    const value = encodeURIComponent(JSON.stringify({ token, id: id ?? null }));
    const secure = isSecure() ? '; Secure' : '';

    document.cookie = `${COOKIE_NAME}=${value}; Domain=${getCookieDomain()}; Path=/; Max-Age=${MAX_AGE_SECONDS}; SameSite=Lax${secure}`;
}

export function getSessionCookie() {

    const match = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${COOKIE_NAME}=`));

    if (!match) {
        return null;
    }

    try {
        return JSON.parse(decodeURIComponent(match.substring(COOKIE_NAME.length + 1)));
    } catch (error) {
        return null;
    }
}

export function removeSessionCookie() {

    const secure = isSecure() ? '; Secure' : '';

    document.cookie = `${COOKIE_NAME}=; Domain=${getCookieDomain()}; Path=/; Max-Age=0; SameSite=Lax${secure}`;
    document.cookie = `${COOKIE_NAME}=; Path=/; Max-Age=0; SameSite=Lax${secure}`;
}
